module.exports = __webpack_public_path__ + "static/media/icon_off_market.19fec0ba.svg";